import { generatePopupConfig } from '@/features/Popup/helpers/generatePopupConfig';
import './styles/index.scss';
import ExitIcon from '@/features/Icons/ExitIcon';
import { usePopup } from '@/features/Popup/usePopup';
import { useAppOrientation } from '@/lostHooks/orientation/useOrientation';
import { SHOWOFF_ELEMENTS } from '@/features/Showoff';

import { POPUP_TYPES } from '@/features/Popup/constants';

const ExitButton = ({ dashboard }: { dashboard?: boolean }) => {
  const { showPopup } = usePopup();
  const orientation = useAppOrientation();

  const handleExit = () => {
    showPopup(generatePopupConfig(POPUP_TYPES.EXIT), POPUP_TYPES.EXIT);
  };

  return (
    <div
      className={`exit-button exit-button--${orientation} ${
        dashboard ? 'exit-button--dashboard' : ''
      }`}
      onClick={handleExit}
      onKeyDown={handleExit}
      data-showoff={SHOWOFF_ELEMENTS.EXIT_BUTTON}
      data-showoff-notification="false"
      data-testid="exit-button"
    >
      <div className={`exit-button__icon exit-button__icon--${orientation}`}>
        <ExitIcon />
      </div>
      <p className={`exit-button__text exit-button__text--${orientation}`}>
        Exit
      </p>
    </div>
  );
};

export default ExitButton;
